import * as Sentry from "@sentry/react";

import config from "app.config";

export function initSentry() {
  try {
    if (config.sentryDsn) {
      Sentry.init({
        dsn: config.sentryDsn,
        environment: config.environment,
        release: config.revision,

        // Capture request headers, user IP, and other PII to help debug errors
        dataCollection: {
          userInfo: true,
          cookies: true,
          httpHeaders: true,
        },

        // Capture 10% of transactions for performance monitoring
        tracesSampleRate: config.environment === "staging" ? 1 : 0.1,
        tracePropagationTargets: [
          "localhost",
          new RegExp(String.raw`^${config.apiUrl.replace(".", "\\.")}`),
        ],

        // Capture session replays for 10% of sessions, 100% of sessions with errors
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,

        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            // Show real page text/input values in replays so they're actually
            // useful for investigating issues (default masks everything as
            // "*****"). Sensitive fields are masked explicitly below instead
            // of relying on masking everything by default.
            maskAllText: false,
            maskAllInputs: false,
            // Always mask these regardless of the flags above. Add the
            // `data-sentry-mask` attribute to any other element that renders
            // sensitive values (tokens, secrets) as plain text/readOnly input.
            mask: [
              "input[type='password']",
              ".sentry-mask",
              "[data-sentry-mask]",
            ],
          }),
        ],
      });
    }
  } catch (err) {
    console.error(err);
  }
}
